var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDcl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1750901797605,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11478,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 51.2c-254.464 0-460.8 206.336-460.8 460.8s206.336 460.8 460.8 460.8 460.8-206.336 460.8-460.8-206.336-460.8-460.8-460.8z m280.064 740.864c-74.24 74.24-175.104 116.224-280.064 115.712-104.96 0-205.824-41.472-280.064-115.712S115.712 616.96 115.712 512s41.472-205.824 116.224-280.064C306.176 157.696 407.04 115.712 512 116.224c104.96 0 205.824 41.472 280.064 116.224 74.24 74.24 116.224 175.104 115.712 280.064 0.512 104.448-41.472 205.312-115.712 279.552z",
    "p-id": 11479,
    fill: "#bbbbbb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M820.736 568.32H495.104c-16.384 0-29.184-13.312-29.184-29.184v-2.56c0-16.384 13.312-29.184 29.184-29.184h325.12c16.384 0 29.696 13.312 29.696 29.184v2.56c0 15.872-13.312 29.184-29.184 29.184z",
    "p-id": 11480,
    fill: "#bbbbbb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M527.36 213.504v325.12c0 15.872-13.312 29.184-29.184 29.184h-2.56c-15.872 0-29.184-13.312-29.184-29.184V213.504c0-15.872 13.312-29.184 29.184-29.184h2.56c15.872 0 29.184 13.312 29.184 29.184z",
    "p-id": 11481,
    fill: "#bbbbbb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcl);
export default __webpack_public_path__ + "static/media/dcl.47eac43d45f4aed6fd572e1345d543bd.svg";
export { ForwardRef as ReactComponent };